import { translate } from '../../../../../common/i18n';

Blockly.Blocks.reset_steps = {
    init: function init() {
        this.appendDummyInput().appendField(translate('Reset Virtual Steps'));
        this.setColour('#f2f2f2');
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setTooltip(translate('It will change the virtual steps count to 0'));
    },
    onchange: function onchange() {},
};

Blockly.JavaScript.reset_steps = () => 'BinaryBotPrivateVirtualSettings.steps = 0;';



// WEBPACK FOOTER //
// ./src/botPage/view/blockly/blocks/virtualtrades/resetsteps.js